import { Toaster as Sonner, toast } from 'sonner';
import { useTheme } from '@/components/theme/theme-provider';

/**
 * App toaster. Async actions surface pending/success/failure feedback here
 * (UI_DESIGN.md); it mirrors the active theme.
 */
export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'group rounded-md border bg-card text-card-foreground shadow-md text-sm',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
        },
      }}
    />
  );
}

export { toast };
